import {
  PILOT_PROGRAM,
  YES,
  NO,
  PILOT_CODE
} from "../Helpers/constants.js";

export function isEmpty(val) {
  if (!val || val.trim().length === 0 || val === "select") {
    return true
  } else {
    return false;
  }
}

export function isEmptyOrCero(val) {
  if (!val || val.trim().length === 0 || val === "select" || val === "0") {
    return true
  } else {
    return false;
  }
}

export function isValidEmail(val) {
  return val.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
}

export function isNumeric(val) {
  let numbers = /^[0-9]+$/;
  if (val.match(numbers)) {
    return true;
  }
}

export function onlyNumeric(val) {
  if (!isEmpty(val)) {
    return val.replace(/[^0-9]/g, '');
  } else {
    return "";
  }
}

export function onlyNumericAndDash(val) {
  if (!isEmpty(val)) {
    return val.replace(/[^\d -]+/g, '');
  } else {
    return "";
  }
}

export function isValidZipCode(code) {
  if (code.length === 5 && isNumeric(code)) {
    return true;
  }
}
// Logic,  Required  if Bed Shaker > 0   bed Shaker = dhhSerialNumber
export function isValidDhhSerialNumber(dhhAlarmsValid, dhhSerialNumber, dhhAlarmsSelected) {
  if (dhhAlarmsValid && dhhAlarmsSelected !== "0" && isEmpty(dhhSerialNumber)) {
    return false;
  }
  return true;
}

export function isWildfireServiceValid(serviceTypeSelected, pilotStatus, pilotCode, isWildfireRequestService, wildfireService) {
  if (serviceTypeSelected === PILOT_PROGRAM && pilotStatus === 1 && pilotCode === PILOT_CODE.WILDFIRE && isWildfireRequestService === YES && isEmpty(wildfireService)) {
    return false;
  }
  return true;
}

export function isWildfireReferPartnerValid(serviceTypeSelected, pilotStatus, pilotCode, isWildfireReferHousehold, wildfireReferPartner) {
  if (serviceTypeSelected === PILOT_PROGRAM && pilotStatus === 1 && pilotCode === PILOT_CODE.WILDFIRE && isWildfireReferHousehold === YES && isEmpty(wildfireReferPartner)) {
    return false;
  }
  return true;
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var matchPartial1 = cleaned.match(/^(\d{3})$/);
  var matchPartial2 = cleaned.match(/^(\d{3})(\d{3})$/);
  var matchWhole = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (matchPartial1) {
    return [matchPartial1[1], '-'].join('');
  }
  if (matchPartial2) {
    return [matchPartial2[1], '-', matchPartial2[2], '-'].join('');
  }
  if (matchWhole) {
    return [matchWhole[1], '-', matchWhole[2], '-', matchWhole[3]].join('');
  }
  return phoneNumberString;
}

export function validateYouthServed(peopleServedSelected, youthServedSelected) {
  if (isEmpty(youthServedSelected)) {
    return true;
  }
  if (!isEmpty(peopleServedSelected) && !isEmpty(youthServedSelected)) {
    if (
      parseInt(youthServedSelected, 10) < parseInt(peopleServedSelected, 10)
    ) {
      return true;
    } else {
      return false;
    }
  }
}

export function validateSeniorsServed(peopleServedSelected, youthServedSelected, seniorsServedSelected) {
  if (isEmpty(seniorsServedSelected)) {
    return true;
  }
  if (
    !isEmpty(peopleServedSelected) &&
    !isEmpty(seniorsServedSelected)
  ) {
    let tempYouthServed = (isEmpty(youthServedSelected) ? 0 : parseInt(youthServedSelected, 10));
    if (
      tempYouthServed +
      parseInt(seniorsServedSelected, 10) <=
      parseInt(peopleServedSelected, 10)
    ) {
      return true;
    } else {
      return false;
    }
  }
}

export function validateAlarmsWorkingAndPreExistinAlarms(preexistingAlarmsSelected, preexistingAlarmsWorkingSelected) {
  let tempPreexistingAlarmsSelected = (isEmpty(preexistingAlarmsSelected) ? 0 : parseInt(preexistingAlarmsSelected, 10));
  let tempPreexistingAlarmsWorkingSelected = (isEmpty(preexistingAlarmsWorkingSelected) ? 0 : parseInt(preexistingAlarmsWorkingSelected, 10));
  if (tempPreexistingAlarmsWorkingSelected > tempPreexistingAlarmsSelected) {
    return false;
  } else {
    return true;
  }
}

export function validateIdafnServed(peopleServedSelected, idafnServedSelected) {
  if (isEmpty(idafnServedSelected)) {
    return true;
  }
  if (!isEmpty(peopleServedSelected) && !isEmpty(idafnServedSelected)) {
    if (
      parseInt(idafnServedSelected, 10) <= parseInt(peopleServedSelected, 10)
    ) {
      return true;
    } else {
      return false;
    }
  }
}

export function validateMilitaryServed(peopleServedSelected, militaryServedSelected) {
  if (isEmpty(militaryServedSelected)) {
    return true;
  }
  if (!isEmpty(peopleServedSelected) && !isEmpty(militaryServedSelected)) {
    if (
      parseInt(militaryServedSelected, 10) <=
      parseInt(peopleServedSelected, 10)
    ) {
      return true;
    } else {
      return false;
    }
  }
}